<template>
  <v-dialog :value="value" width="850px" @input="$emit('input', false)">
    <v-card>
      <v-card-title>
        <span>Última atualização por franqueado</span>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="franchiseeAccounts"
          :loading="loading"
          sort-by="status_reporter.max_date"
          sort-desc
          fixed-header
          disable-pagination
          hide-default-footer
          :height="tableHeight"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <span>{{ item.name }}</span>
              </td>
              <td>
                <mf-icon small fill :color="item.formattedStatus.color">fiber_manual_record</mf-icon>
                <span>{{ item.formattedStatus.formattedDate }}</span>
                <span> {{ item.formattedStatus.daysAgo }} </span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span class="help-icon" v-on="on">
                      <mf-icon small>info</mf-icon>
                    </span>
                  </template>
                  <span>{{ item.formattedStatus.text }}</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-row class="px-3 pb-1" no-gutters>
          <export-data :data-fetcher="csvExport" :disabled="loading" filename="Atualização de Franqueados" />
          <v-spacer />
          <mf-button label="Fechar" @click="$emit('input', false)" />
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import gql from 'graphql-tag'
import { DateTime } from 'luxon'
import { parseStatus } from '@/components/last-updated/helper.js'
const QUERY_GET_FRANCHISEE_ACCOUNTS = gql`
  {
    franchiseeAccounts(active: true) {
      _id
      name
      active
      status_reporter {
        max_date
        status
      }
      franchise_status_reporter {
        max_date
        status
      }
    }
  }
`

export default {
  components: {
    ExportData: () => import('@/components/export-data/ExportData.vue'),
  },
  props: {
    value: Boolean,
  },
  data: () => ({
    loading: false,
    franchiseeAccounts: [],
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Franqueado',
          value: 'name',
          width: '70%',
        },
        {
          text: 'Última Atulização',
          value: 'franchise_status_reporter.max_date',
          width: '30%',
        },
      ]
    },
    tableHeight() {
      if (!this.franchiseeAccounts?.length) return '200px'
      const calculatedHeight = 48 * this.franchiseeAccounts.length
      return `${Math.min(Math.max(calculatedHeight, 200), 600)}px`
    },
  },
  watch: {
    value(value) {
      if (!value || this.franchiseeAccounts.length) return
      this.fetchFranchiseeAccounts()
    },
  },
  methods: {
    async fetchFranchiseeAccounts() {
      this.loading = true
      try {
        const { data } = await this.$apollo.query({
          query: QUERY_GET_FRANCHISEE_ACCOUNTS,
        })
        this.franchiseeAccounts = data.franchiseeAccounts.map((account) => ({ ...account, formattedStatus: this.formatStatus(account) }))
      } catch (e) {
        console.log('Failed to fetch franchisees', e)
        this.$snackbar({ message: 'Erro ao buscar franqueados.', snackbarColor: 'error' })
      }
      this.loading = false
    },
    formatStatus(account) {
      if (!account.active) {
        return { formattedDate: '-', daysAgo: '', text: 'Conta inativa', color: '#bfbfbf' }
      }
      if (!account?.franchise_status_reporter?.status) {
        return { formattedDate: '-', daysAgo: '', text: 'Sem status', color: '#bfbfbf' }
      }
      const parsedStatus = parseStatus(account.franchise_status_reporter.status)
      const now = DateTime.now()
      let formattedDate = '-'
      let daysAgo = ''
      if (account?.franchise_status_reporter?.max_date) {
        const dateObj = DateTime.fromFormat(account?.franchise_status_reporter?.max_date, 'yyyy-MM-dd')
        formattedDate = dateObj.toFormat('dd/MM/yyyy')
        const days = Math.floor(now.diff(dateObj, ['days']).days)
        daysAgo = `(${days} ${days === 1 ? 'dia' : 'dias'})`
      }
      return {
        formattedDate,
        daysAgo,
        text: parsedStatus.text,
        color: parsedStatus.color,
      }
    },
    csvExport() {
      const exportData = {
        headers: ['Franqueado', 'Status', 'Última Atualização'],
        rows: this.franchiseeAccounts.map((account) => [account.name, account.franchise_status_reporter?.status, account.formattedStatus.formattedDate]),
      }
      return exportData
    },
  },
}
</script>
